import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Content from '../Content'
import {
  ParticleCube,
  ParticleRectangle,
  ParticleTriangle,
  ParticleCircle,
} from '../Particles'

const ParticleTitle = ({ hero, title, subTitle, particleSize, particles }) => (
  <Content>
    <StyledParticleTitle hero={hero}>
      {hero ? title : <StyledHeader>{title}</StyledHeader>}
      {particles.map(item => {
        const variant = item.particle_variant
        switch (variant) {
          case 'ParticleCube':
            return (
              <ParticleCube
                key={Math.random()}
                type={item.particle_type}
                size={particleSize}
                color={item.particle_color}
                style={item.particle_position}
                mobile={item.particle_mobile_position}
              />
            )
          case 'ParticleRectangle':
            return (
              <ParticleRectangle
                key={Math.random()}
                type={item.particle_type}
                size={particleSize}
                color={item.particle_color}
                style={item.particle_position}
                mobile={item.particle_mobile_position}
              />
            )
          case 'ParticleTriangle':
            return (
              <ParticleTriangle
                key={Math.random()}
                size={particleSize}
                color={item.particle_color}
                style={item.particle_position}
                mobile={item.particle_mobile_position}
              />
            )
          case 'ParticleCircle':
            return (
              <ParticleCircle
                key={Math.random()}
                size={particleSize}
                color={item.particle_color}
                style={item.particle_position}
                mobile={item.particle_mobile_position}
              />
            )
          default:
            return false
        }
      })}
    </StyledParticleTitle>
    {subTitle && <SubTitle>{subTitle}</SubTitle>}
  </Content>
)

ParticleTitle.defaultProps = {
  hero: false,
  particleSize: 1,
  subTitle: null,
}

ParticleTitle.propTypes = {
  title: PropTypes.string.isRequired,
  hero: PropTypes.bool,
  particleSize: PropTypes.number,
  particles: PropTypes.arrayOf(
    PropTypes.shape({
      particle_variant: PropTypes.string.isRequired,
      particle_type: PropTypes.string,
      particle_color: PropTypes.string.isRequired,
      particle_position: PropTypes.shape({}).isRequired,
      particle_mobile_position: PropTypes.shape({}),
    }),
  ).isRequired,
  subTitle: PropTypes.string,
}

const StyledHeader = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  text-align: center;
  padding: 80px 0;
  position: relative;
`

const StyledParticleTitle = styled.h1`
  color: ${props => (!props.hero ? 'black' : 'white')};
  text-transform: ${props => (!props.hero ? 'none' : 'uppercase')};
  font-weight: 800;
  font-size: 34px;
  max-width: 100%;
  position: relative;
  margin-top: 0;
  line-height: 0.84;

  @media (min-width: 568px) {
    font-size: 55px;
  }

  @media (min-width: 960px) {
    font-size: ${props => (!props.hero ? '55px' : '70px')};
    margin-top: 20px;
    margin-bottom: 70px;
  }
`

const SubTitle = styled.p`
  text-align: center;
  margin-top: -110px;
  margin-bottom: 80px;
  font-weight: 300;

  @media (min-width: 568px) {
    margin-top: -120px;
    font-size: 26px;
  }
`

export default ParticleTitle
